import { apps } from "../index-client.mjs";
const hapticFeedback = apps.hapticFeedback;
const triggerHapticFeedback = hapticFeedback.triggerHapticFeedback;
export {
  hapticFeedback,
  triggerHapticFeedback
};
/*                                     */
